<template>
  <div class="container-violation" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Hostess Violation -->
          <span class="tit-left">{{ $t('lang.Violation.k006') }}</span>
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/views/P2_Page/Violation/default/rule_new.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="page-content">
      <div class="summary-section">
        <div class="section-header">
          <div class="section-bar"></div>
          <span class="section-title">{{ weekSectionTitle }}</span>
        </div>
        <div class="stat-cards">
          <div class="stat-card">
            <div class="stat-value">{{ totalVioWeek }}</div>
            <div class="stat-label">{{ $t('lang.Violation.k007') }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ totalDedWeek }}</div>
            <div class="stat-label">{{ $t('lang.Violation.k001') }}</div>
          </div>
        </div>
      </div>

      <div class="records-section">
        <div class="section-header">
          <div class="section-bar"></div>
          <span class="section-title">{{ $t('lang.Violation.k008') }}</span>
        </div>

        <div class="list-search-box">
          <div class="search-input">
            <input v-model="hostId" :placeholder="$t('lang.Violation.k002')" class="input" type="text" />
            <div class="search-divider"></div>
            <div class="search-btn" @click="handleSearch">
              <img class="search-icon" src="@/assets/packageAssets/views/P2_Page/Violation/default/search_new.webp" alt="" />
            </div>
          </div>
          <div class="search-select" @click="handleTimePop">
            <span v-if="chooseTime">{{ handleMoment(chooseTime, 'YYYY-MM-DD') }}</span>
            <span v-else>{{ weekFilterText }}</span>
            <img :class="{ activeTime: showPop }" src="@/assets/packageAssets/common/arrow06.webp" alt="" />
          </div>
          <div class="refresh" @click="handleClear">
            <img src="@/assets/packageAssets/views/P2_Page/Violation/default/refresh_new.webp" alt="" />
          </div>
        </div>

        <div class="data-table">
          <div class="table-header">
            <div class="th">{{ $t('lang.Violation.k009') }}</div>
            <div class="th">{{ $t('lang.Violation.k010') }}</div>
            <div class="th">{{ $t('lang.BaseCommon.k048') }}</div>
            <div class="th">{{ $t('lang.Violation.k003') }}</div>
          </div>

          <van-list class="list-data-box" v-model="loading" loading-text=" " offset="200" :finished="finished" @load="onLoad">
            <div class="table-row" v-for="(item, index) in listData" :key="index">
              <div class="td td-id">
                <div class="copy-id" @click="copyId(item.presentId)">
                  <span class="id">{{ item.presentId }}</span>
                  <img class="copy" src="@/assets/packageAssets/views/P2_Page/Violation/default/copy_new.webp" alt="" />
                </div>
              </div>
              <div class="td td-center">{{ item.punishAmount }}</div>
              <div class="td td-reason">{{ item.punishReason }}</div>
              <div class="td td-time">
                <p>{{ handleMoment(item.punishTime, 'DD MMM') }}</p>
                <p>{{ handleMoment(item.punishTime, 'YYYY') }}</p>
              </div>
            </div>
            <div v-if="listData && !listData.length && !loading" class="empty-placeholder"></div>
          </van-list>
        </div>
      </div>
    </div>

    <CTimeDay :showPop="showPop" :min-date="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchVioData } from '@/api/imee'
import { getBaseFeature } from '@/assets/style/variable'

import CTimeDay from '@/components/CTimeDay'

export default {
  components: { CTimeDay },
  data() {
    return {
      showPop: false,
      weekTabIndex: 0,
      listQuery: {
        offset: 0,
        limit: 5,
      },
      hostId: null,
      chooseTime: null,
      minDate: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000),
      listData: [],
      loading: false,
      finished: false,
      totalDedWeek: 0,
      totalVioWeek: 0,
    }
  },
  computed: {
    weekSectionTitle() {
      return this.weekTabIndex === 0 ? this.$t('lang.BaseCommon.k034') : this.$t('lang.BaseCommon.k042')
    },
    weekFilterText() {
      return this.weekTabIndex === 0 ? this.$t('lang.BaseCommon.k034') : this.$t('lang.BaseCommon.k042')
    },
  },
  created() {
    this.weekTabIndex = Number(this.$route.query.week || '0')
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    handleClear() {
      this.hostId = null
      this.chooseTime = null
      this.fetchData()
    },
    handleSearch() {
      this.fetchData()
    },
    handleCurrentDate(time) {
      this.chooseTime = this.handleMoment(time, 'YYYY-MM-DD')
      this.fetchData()
    },
    fetchData() {
      this.listData = []
      this.listQuery.offset = 0
      this.finished = false
      this.fetchVioData()
    },
    onLoad() {
      this.fetchVioData()
    },
    fetchVioData() {
      this.loading = true
      const params = {
        hostPresentId: this.hostId,
        agentDay: this.chooseTime ? this.chooseTime : this.weekTabIndex,
        ...this.listQuery,
      }
      apiFetchVioData(params).then((res) => {
        if (res) {
          this.loading = false
          if (res.weekPunishBeanSum || res.weekPunishBeanSum === 0) {
            this.totalDedWeek = res.weekPunishBeanSum
          }
          if (res.weekPunishHostNum || res.weekPunishHostNum === 0) {
            this.totalVioWeek = res.weekPunishHostNum
          }
          this.listData = this.listData.concat(res.punishRecordList)

          if (res.punishRecordList.length < this.listQuery.limit) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.listQuery.offset = this.listData.length
        }
      })
    },
    copyId(presentId) {
      this.handleCopy(presentId, this.$t('lang.BaseCommon.k071'))
    },
    handleToRule() {
      this.$router.push({ path: '/rules', query: { backType: 'previous' } })
    },
    handleTimePop() {
      this.showPop = true
    },
    closePop() {
      this.showPop = false
    },
  },
}
</script>
<style lang="scss" scoped>
.container-violation {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fefefe;

  .custom-nav-block {
    background-color: #fefefe;
  }

  .page-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 4px 16px 16px;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 0;

    .section-bar {
      width: 4px;
      height: 14px;
      background: #925e0d;
      border-radius: 2px;
      flex-shrink: 0;
    }

    .section-title {
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-20);
      line-height: 26px;
      color: #333333;
    }
  }

  .summary-section {
    display: flex;
    flex-direction: column;
  }

  .stat-cards {
    display: flex;
    gap: 8px;
    padding: 4px 0;
  }

  .stat-card {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    min-height: 86px;
    padding: 13px 14px;
    background: linear-gradient(180deg, #fff0d9 0%, #fefcf8 100%);
    border-radius: 12px;
    box-sizing: border-box;

    .stat-value {
      flex: 1;
      font-family: var(--number-font);
      font-weight: var(--fw-400);
      font-size: 24px;
      line-height: 32px;
      color: #925e0d;
    }

    .stat-label {
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-body-18);
      color: #ad8a55;
    }
  }

  .records-section {
    display: flex;
    flex-direction: column;
  }

  .list-search-box {
    display: flex;
    align-items: stretch;
    gap: 10px;
    padding: 4px 0;

    .search-input {
      display: flex;
      flex: 1;
      align-items: center;
      min-width: 0;
      background: #f6f6f5;
      border-radius: 8px;
      overflow: hidden;

      .input {
        flex: 1;
        min-width: 0;
        height: 44px;
        padding: 0 12px;
        border: none;
        background: transparent;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #333333;

        &::placeholder {
          color: #cccccc;
        }
      }

      .search-divider {
        width: 1px;
        height: 16px;
        background: #d9d9d9;
        flex-shrink: 0;
      }

      .search-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        flex-shrink: 0;
      }

      .search-icon {
        width: 24px;
        height: 24px;
      }
    }

    .search-select {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 12px;
      background: #f6f6f5;
      border-radius: 8px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-16);
      line-height: var(--lh-title-20);
      color: #666666;
      white-space: nowrap;
      flex-shrink: 0;

      > img {
        width: 16px;
        height: 16px;
      }

      .activeTime {
        transform: rotateX(180deg);
      }
    }

    .refresh {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      background: #f6f6f5;
      border-radius: 8px;
      flex-shrink: 0;

      > img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .data-table {
    border: 2px solid #f9f8f6;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    margin-top: 4px;
    background: transparent;

    .table-header {
      display: grid;
      grid-template-columns: 28% 28% 28% 16%;

      .th {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 4px;
        background: #f9f8f6;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-title-20);
        color: #925e0d;
        text-align: center;
        white-space: nowrap;

        &:nth-child(1) {
          border-right: 1px solid #edeae3;
        }

        &:nth-child(2) {
          border-left: 1px solid #edeae3;
          border-right: 1px solid #edeae3;
        }

        &:nth-child(3) {
          border-left: 1px solid #edeae3;
          border-right: 1px solid #edeae3;
        }

        &:nth-child(4) {
          border-left: 1px solid #edeae3;
        }
      }
    }

    .table-row {
      display: grid;
      grid-template-columns: 28% 28% 28% 16%;
    }

    .td {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 8px;
      border-bottom: 1px solid #f9f8f6;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-12);
      line-height: var(--lh-label-16);
      color: #666666;
      align-self: stretch;

      &.td-id {
        padding: 12px 8px;
      }

      &.td-center {
        text-align: center;
      }

      &.td-reason {
        text-align: center;
        word-break: break-word;
      }

      &.td-time {
        flex-direction: column;
        gap: 2px;
        text-align: right;

        p {
          margin: 0;
          width: 100%;
        }
      }
    }

    .table-row:last-child .td {
      border-bottom: none;
    }

    .copy-id {
      display: flex;
      align-items: center;
      gap: 2px;

      .id {
        color: #666666;
        font-size: var(--fs-12);
        line-height: var(--lh-label-16);
      }

      .copy {
        width: 16px;
        height: 16px;
      }
    }
  }

  .list-data-box {
    display: block;
    width: 100%;
    max-height: calc(100vh - 360px);
    overflow-y: auto;

    ::v-deep .van-list__finished-text {
      font-family: var(--string-font);
      font-size: var(--fs-12) !important;
      line-height: var(--lh-body-18) !important;
      color: #666 !important;
    }
  }

  .empty-placeholder {
    width: 100%;
    height: 100px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-violation {
    .data-table {
      .td.td-time {
        text-align: left;
      }
    }
  }
}
</style>
